"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { tv } from "tailwind-variants";
import { SearchOff, SignalDisconnected } from "../../icons";
import { classNames } from "../../utils/classNames";
import { Button } from "../Button";
import { CenterAligned } from "../CenterAligned";
import { TextBody, TextDisplay } from "../Text";
const emptyStateVariants = tv({
  slots: {
    container: "",
    textContainer: "",
    iconContainer: "rounded bg-bg-additional-2"
  },
  variants: {
    variant: {
      "no-data": "",
      "no-chart-data": "",
      "no-results": "",
      "no-results-with-filters": ""
    },
    size: {
      md: {
        container: "gap-4",
        textContainer: "gap-2",
        iconContainer: "size-12"
      },
      lg: {
        container: "h-full gap-6",
        textContainer: "gap-6",
        iconContainer: "size-20"
      }
    }
  }
});
const DEFAULT_CONTENT = {
  "no-data": {
    title: "No data found",
    description: "Data seems to be offline. Try refreshing the page.",
    icon: SignalDisconnected
  },
  "no-chart-data": {
    title: "No data found",
    description: "Try adjusting the timeframe.",
    icon: SignalDisconnected
  },
  "no-results": {
    title: "No results found",
    description: "We've been searching the blockchain.",
    icon: SearchOff
  },
  "no-results-with-filters": {
    title: "No results found",
    description: "Try removing some filters to view more results.",
    icon: SearchOff
  }
};
const ICON_SIZE = {
  md: 24,
  lg: 44
};
export function EmptyState(t0) {
  const $ = _c(41);
  const {
    className,
    variant,
    size: t1,
    title: t2,
    description: t3,
    icon: t4,
    showIcon: t5,
    onResetFilters,
    extra
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const title = t2 === undefined ? DEFAULT_CONTENT[variant].title : t2;
  const description = t3 === undefined ? DEFAULT_CONTENT[variant].description : t3;
  const Icon = t4 === undefined ? DEFAULT_CONTENT[variant].icon : t4;
  const showIcon = t5 === undefined ? true : t5;
  let T0;
  let T1;
  let t6;
  let t7;
  let t8;
  let textContent;
  if ($[0] !== Icon || $[1] !== className || $[2] !== description || $[3] !== showIcon || $[4] !== size || $[5] !== title || $[6] !== variant) {
    const {
      container,
      textContainer,
      iconContainer
    } = emptyStateVariants({
      variant,
      size
    });
    let t9;
    bb0: {
      if (size === "md") {
        let t10;
        if ($[13] !== title) {
          t10 = title && <TextBody color="text-primary" size="md" weight="semibold">{title}</TextBody>;
          $[13] = title;
          $[14] = t10;
        } else {
          t10 = $[14];
        }
        let t11;
        if ($[15] !== description) {
          t11 = description && <TextBody color="text-secondary">{description}</TextBody>;
          $[15] = description;
          $[16] = t11;
        } else {
          t11 = $[16];
        }
        let t12;
        if ($[17] !== t10 || $[18] !== t11) {
          t12 = <>{t10}{t11}</>;
          $[17] = t10;
          $[18] = t11;
          $[19] = t12;
        } else {
          t12 = $[19];
        }
        t9 = t12;
        break bb0;
      }
      let t10;
      if ($[20] !== title) {
        t10 = title && <TextDisplay color="text-primary" size="md">{title}</TextDisplay>;
        $[20] = title;
        $[21] = t10;
      } else {
        t10 = $[21];
      }
      let t11;
      if ($[22] !== description) {
        t11 = description && <TextBody color="text-secondary">{description}</TextBody>;
        $[22] = description;
        $[23] = t11;
      } else {
        t11 = $[23];
      }
      let t12;
      if ($[24] !== t10 || $[25] !== t11) {
        t12 = <>{t10}{t11}</>;
        $[24] = t10;
        $[25] = t11;
        $[26] = t12;
      } else {
        t12 = $[26];
      }
      t9 = t12;
    }
    textContent = t9;
    T1 = CenterAligned;
    t7 = classNames(container(), className);
    t8 = showIcon && <CenterAligned className={iconContainer()}><Icon fill="text-secondary" size={ICON_SIZE[size]} /></CenterAligned>;
    T0 = CenterAligned;
    t6 = textContainer();
    $[0] = Icon;
    $[1] = className;
    $[2] = description;
    $[3] = showIcon;
    $[4] = size;
    $[5] = title;
    $[6] = variant;
    $[7] = T0;
    $[8] = T1;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = textContent;
  } else {
    T0 = $[7];
    T1 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    textContent = $[12];
  }
  let t9;
  if ($[27] !== T0 || $[28] !== t6 || $[29] !== textContent) {
    t9 = <T0 className={t6}>{textContent}</T0>;
    $[27] = T0;
    $[28] = t6;
    $[29] = textContent;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== onResetFilters || $[32] !== variant) {
    t10 = onResetFilters && variant === "no-results-with-filters" && <Button onClick={onResetFilters} variant="tertiary">Clear filters</Button>;
    $[31] = onResetFilters;
    $[32] = variant;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== T1 || $[35] !== extra || $[36] !== t10 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t11 = <T1 className={t7}>{t8}{t9}{t10}{extra}</T1>;
    $[34] = T1;
    $[35] = extra;
    $[36] = t10;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
}